import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from './services/authentication.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {

    userType: string;

    constructor(private authService: AuthenticationService) { }

    ngOnInit() {
        console.log('Inicio de la aplicación');
        this.authService.userType.subscribe(type => {
            this.userType = type;
        });
    }
}
